import React from 'react'

import { FerModalQuery } from '~/generated/graphql'
import { CarouselControls, CarouselImage, CarouselItem, CarouselProvider } from '~/shared/molecules/Carousel'

import { StyledCarouselButton, StyledCarouselContent } from './FERModalCarouselShards'

type FestivalEditionRestaurant = NonNullable<FerModalQuery['festivalEditionRestaurant']>

export function FERModalCarousel({
  imageFiles,
  restaurantName = '',
}: {
  imageFiles: FestivalEditionRestaurant['imageFiles']
  restaurantName: FestivalEditionRestaurant['restaurant']['name']
}) {
  return (
    <CarouselProvider autoPlay={false}>
      <StyledCarouselContent>
        {imageFiles.map((image, i) => {
          return (
            <CarouselItem key={image.id}>
              <CarouselImage src={image?.preview || image?.original || ''} alt={restaurantName} index={i} />
            </CarouselItem>
          )
        })}
      </StyledCarouselContent>
      <CarouselControls Button={StyledCarouselButton} />
    </CarouselProvider>
  )
}
